import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'

export default class extends Controller {
  static targets = []
  static values = {}

  connect() {
    $(this.element).on('change.zf.tabs', (ev, tab, panel)=> this.handleEvent(ev, tab, panel))
    $(this.element).on('deeplink.zf.tabs', (ev, tab, panel)=> this.handleEvent(ev, tab, panel))
  }

  disconnect() {
    //abnegate('change.zf.tabs', this.delegate1)
    //abnegate('deeplink.zf.tabs', this.delegate2)
  }

  handleEvent(ev, tab, panel) {
    const event = new CustomEvent("activate-tab");
    panel.get(0).dispatchEvent(event);
  }
}
